import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, catchError, tap, switchMap } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { BaseService } from "./base.service";
import { IKeyContact } from "../interfaces/ikeycontact";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";

@Injectable()
export class KeyContactService extends BaseService {
    constructor(httpClient: HttpClient, toastr: ToastrService, store: Store<IAppStore>) {
        super(httpClient, toastr, store);
    }

    /**
     * Get a list of all updates
     */
    getAll(): Observable<IKeyContact[]> {
        return super.get(`/api/keycontact`).pipe(map((res: any) => res));
    }

    /**
     * Gets a specific security group by id
     * @param id
     */
    getKeyContact(id: number): Observable<IKeyContact> {
        return super.get(`/api/keycontact/${id}`).pipe(map((res: any) => res as IKeyContact));

    }
    /**
     * Creates a user
     * @param user
     */
    create(user: IKeyContact): Observable<IKeyContact> {
        return super.post("/api/keycontact", user).pipe(map((res: any) => res as IKeyContact));
    }

    /**
     * Creates a user
     * @param user
     */
    update(user: IKeyContact): Observable<IKeyContact> {
        return super.put("/api/keycontact", user).pipe(map((res: any) => res as IKeyContact));
    }

}






